import React from 'react';
import Typography from '@mui/material/Typography';
import clsx from 'clsx';
import useStyles from './styles';

const LOGO_ALT_TEXT = 'ELEVATOR Icon';

export type CopyrightProps = {
  className?: string;
};

const BrandMark = ({ className }: { className: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width={20}
    height={20}
    className={className}
    role="img"
    aria-label={LOGO_ALT_TEXT}
  >
    <g stroke="none" strokeWidth={1} fill="none" fillRule="evenodd">
      <g transform="translate(0, 3)">
        <polygon
          stroke="#F83A34"
          fillOpacity={0.15}
          fill="#F83A34"
          points="-3.55271368e-15 5.09032042 4.74246669 16.0769801 9.72488809 16.0769801 11.1993655 18.3258423 20.681914 18.3258423 23.9705839 13.3289734 19.2243103 2.30040976 14.2695342 2.30040976 12.7773523 3.19744231e-14 3.24108249 3.19744231e-14"
        />
        <polygon
          fill="#EB3537"
          points="3.43736957 3.9824937 12.9144165 3.9824937 8.17589303 15.0282278"
        />
        <polygon
          fill="#EB3537"
          points="20.8210174 15.0511304 11.3439705 15.0511304 16.0824939 4.00539632"
        />
      </g>
    </g>
  </svg>
);

const Copyright = ({ className }: CopyrightProps) => {
  const { classes } = useStyles();
  const currentYear = new Date().getFullYear();

  return (
    <div className={clsx(classes.root, className)} data-component="Copyright">
      <BrandMark className={classes.brandMark} />
      <Typography variant="subtitle2" className={classes.copyrightText}>
        ELEVATOR © {currentYear} · All Rights Reserved
      </Typography>
    </div>
  );
};

export default Copyright;
